<div class="container">
  <div class="white-box">
    <div class="circle">
      <div *ngIf="!numRadicado" class="inner-circle"><em class="material-icons icon-cancel">cancel</em></div>
      <div *ngIf="numRadicado" class="inner-circle"><em class="material-icons icon-success">done</em></div>
    </div>
    <div class="col-md-10 col-md-offset-1">
      <span [innerHTML]="body"></span>
    </div>
    <div class="info" *ngIf="numRadicado">
      <div class="code">
        <div>
          <h2 >Tu número de radicado es</h2>
          <h1>{{ numRadicado }}</h1>
        </div>
        <div class="">
          <p class="">
            Este código ha sido enviado al correo registrado
            <br>
            <span >{{ userloggedin?.email }}</span>
          </p>
        </div>
      </div>
      <h3>Has finalizado ¿Qué deseas hacer?</h3>
    </div>
    <div class="buttonsContainer">
      <a id="btn-back-home-from-radicate" [routerLink]="'/' + home" class="text-center u-btn button-100 u-btn--line">Volver al inicio</a>
      <a id="btn-request-new-from-radicate" [routerLink]="'/' + prePage" class="mg-lft-10 u-btn u-btn--yellow"
        >Nueva solicitud</a
      >
    </div>
  </div>
</div>
